import React, { useState } from 'react';

import axios from 'axios';
import DummyTest from './dummyTest';

const UploadTest = () => {
  const [uploadedImagePath, setUploadedImagePath] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isUploading, setIsUploading] = useState(false); // ✅ New state

  const handleUpload = async e => {
    e.preventDefault();
    const file = e.target.image.files[0];
    setIsUploading(true);
    setSuccessMessage('');
    setUploadedImagePath('');

    try {
      // Step 1: Get Pre-signed URL from the Backend
      const response = await axios.get('/generate-signed-url', {
        params: {
          fileName: file.name,
          fileType: file.type,
        },
      });

      const { url } = response.data;

      // Step 2: Upload the File to S3
      await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
      });

      // Step 3: Save Uploaded File Information
      // const fileUrl = url.split('?')[0];

      const s3BaseUrl = 'https://my-mani-bucket8080.s3.eu-north-1.amazonaws.com/';
      const imagePath = url.replace(s3BaseUrl, '');

      setUploadedImagePath(imagePath);
      setSuccessMessage('✅ Upload successful!');
    } catch (error) {
      console.error('Upload failed:', error);
    } finally {
      setIsUploading(false); // ✅ End loading
    }
  };

  return (
    <div className="main-container">
      <div className="pd-ltr-20 xs-pd-20-10">
        <div className="min-height-200px dashboard-container">
          <div className="page-header"></div>
        </div>
        <div className="mb-8">
          <form onSubmit={handleUpload} className="mb-4">
            <input type="file" name="image" />
            <button
              type="submit"
              disabled={isUploading}
              className={`px-2 py-1 rounded-lg ml-4 text-white cursor-pointer ${
                isUploading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600'
              }`}
            >
              {isUploading ? 'Uploading...' : 'Upload'}
            </button>
          </form>

          {successMessage && (
            <p
              className={`font-semibold mb-4 ${
                successMessage.includes('successful') ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {successMessage}
            </p>
          )}

          {uploadedImagePath && (
            <div className="max-w-[20rem]">
              <DummyTest src={uploadedImagePath} alt="Uploaded image" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default UploadTest;
